var c = (g, v, i) => new Promise((n, u) => {
  var l = (o) => {
    try {
      t(i.next(o));
    } catch (e) {
      u(e);
    }
  }, f = (o) => {
    try {
      t(i.throw(o));
    } catch (e) {
      u(e);
    }
  }, t = (o) => o.done ? n(o.value) : Promise.resolve(o.value).then(l, f);
  t((i = i.apply(g, v)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getPermissionList as B } from "@oppein/op-utils";
import M from "../approval-table/indexTableItem.vue.js";
import x from "../mall-sp-approval-trigger/index.ce.vue.js";
import { defineComponent as L, useTemplateRef as A, onMounted as P, computed as V, openBlock as T, createElementBlock as z, createElementVNode as E, createVNode as m, withCtx as I, createBlock as O, createCommentVNode as D, Fragment as F } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as G } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as r, unref as _ } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import K from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import U from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import $ from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const ae = /* @__PURE__ */ L({
  __name: "relatedApproval.ce",
  emits: ["submit"],
  setup(g, { expose: v, emit: i }) {
    const n = A("relatedApprovalContainer"), u = A("triggerRef");
    G();
    const l = r(!1), f = r([]), t = r(!0);
    r(0), r([]);
    const o = r(!1), e = r({
      pageSize: 10,
      pageNum: 1,
      applyTypeList: ["bpm_process_djjspecial_judge"],
      businessType: "business_serviceNo",
      status: "pass",
      businessId: "",
      isCreatorId: void 0,
      orderId: "",
      customerId: ""
    });
    P(() => c(this, null, function* () {
    }));
    const d = r(!1), S = V(
      () => !!e.value.orderId && d.value
    );
    let p = null;
    function h(s) {
      return c(this, null, function* () {
        if (d.value = !1, !!s)
          try {
            const a = yield B("MTDS");
            e.value.orderId === s && (d.value = a.some(
              (b) => b.permission === "initGenSpTrial"
            ));
          } catch (a) {
            console.error("获取新增审批权限失败:", a);
          }
      });
    }
    const y = r([]);
    function w(s) {
      return c(this, null, function* () {
        f.value = [], s.selectMode === "Single" ? t.value = !0 : t.value = !1, e.value.businessId = s.businessId || "", e.value.businessType = s.businessType || "business_serviceNo", e.value.isCreatorId = s.isCreatorId, e.value.orderId = s.orderId || "", e.value.customerId = s.customerId || "", t.value = !0, l.value = !0, y.value = s.list || [], yield h(e.value.orderId);
      });
    }
    const C = () => {
      l.value = !1, d.value = !1, p = null, e.value = {
        pageSize: 10,
        pageNum: 1,
        applyTypeList: ["bpm_process_djjspecial_judge"],
        businessType: "business_serviceNo",
        status: "pass",
        businessId: "",
        isCreatorId: void 0,
        orderId: "",
        customerId: ""
      };
    }, N = () => {
      var a;
      const s = {
        code: "bpm_process_djjspecial_judge",
        serviceId: e.value.businessId || "",
        businessType: e.value.businessType,
        businessId: e.value.businessId,
        disabledOptions: !0,
        disabledSearch: !0,
        isRelationOrder: 1,
        isTable: 0,
        orderId: e.value.orderId || "",
        customerId: e.value.customerId || ""
      };
      (a = u.value) == null || a.open(s);
    }, j = (s) => {
      console.log("submit", s), l.value = !1, k("submit", s);
    }, k = i, R = () => {
      l.value = !1, p && (p([]), p = null);
    };
    return v({ open: w }), (s, a) => (T(), z(F, null, [
      E("div", {
        ref_key: "relatedApprovalContainer",
        ref: n
      }, null, 512),
      m(_($), {
        bordered: "",
        show: l.value,
        "onUpdate:show": a[0] || (a[0] = (b) => l.value = b),
        "mask-closable": !1,
        to: n.value || "body"
      }, {
        default: I(() => [
          m(_(K), { show: o.value }, {
            default: I(() => [
              m(_(U), {
                style: { width: "1300px" },
                title: "关联已审批单据",
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: C
              }, {
                default: I(() => [
                  e.value.businessId ? (T(), O(M, {
                    key: 0,
                    ref: "approvalTableRef",
                    onSubmit: j,
                    onCancal: R,
                    businessId: e.value.businessId,
                    businessType: e.value.businessType,
                    isShowAddApprovalButton: !!S.value,
                    onAddApproval: N,
                    list: y.value
                  }, null, 8, ["businessId", "businessType", "isShowAddApprovalButton", "list"])) : D("", !0),
                  m(x, {
                    ref_key: "triggerRef",
                    ref: u
                  }, null, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  ae as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/related-approval/relatedApproval.ce.vue.js
// module id = 1330
// module chunks = 67